import type { BookingSearch } from "@/lib/bookingSearch"
import { distanceKeyToOption } from "@/lib/geolocation/distance/distance"

export const destructureBookingSearchCacheKeys = (
  keys: BookingSearch.Cache.Keys
): BookingSearch.Cache.KeyData => {
  const [_, position, distance, service] = keys

  return {
    position,
    distance: distanceKeyToOption(distance),
    service,
  }
}
